import React, { useState, createContext } from 'react';
import PropTypes from 'prop-types';

export const DetailsContext = createContext({
  currentIndex: 0,
  viewDetails: false,
  showRestOfPillars: false,
  isFiltering: false,
  currentFilter: 'all',
  fadeOutDetails: false,
});

const DetailsProvider = ({ children }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [viewDetails, setViewDetails] = useState(false);
  const [showRestOfPillars, setShowRestOfPillars] = useState(false);
  const [isFiltering, setIsFiltering] = useState(false);
  const [currentFilter, setCurrentFilter] = useState('all');
  const [fadeOutDetails, setFadeOutDetails] = useState(false);

  const valueProps = {
    currentIndex,
    setCurrentIndex,
    viewDetails,
    setViewDetails,
    showRestOfPillars,
    setShowRestOfPillars,
    isFiltering,
    setIsFiltering,
    currentFilter,
    setCurrentFilter,
    fadeOutDetails,
    setFadeOutDetails,
  };

  // console.log('currentIndex:', currentIndex);

  return (
    <DetailsContext.Provider value={valueProps}>
      {children}
    </DetailsContext.Provider>
  );
};

DetailsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DetailsProvider;
